import type { HelpFile } from '../../types/help'
import { PaginationTestIds } from '../../../testids/PaginationTestIds'

export const paginationHelp: HelpFile = {
  docPage: '/docs/help-system/pagination',
  texts: {
    [PaginationTestIds.btnFirstPage]: null,
    [PaginationTestIds.btnLastPage]: null,
    [PaginationTestIds.btnNextPage]: null,
    [PaginationTestIds.btnPreviousPage]: null,
    [PaginationTestIds.paginationInfo]:
      'Shows the current page range and total result count — use the arrows to step through pages or change the page size to load more rows at once.',
    [PaginationTestIds.paginationPageInfo]: null,
    [PaginationTestIds.selectPageSize]: null,
  },
}
